import axios from 'axios';

export default class CaseStudiesListing {
  constructor() {
    this.$el = document.querySelector('.js-case-studies-listing');
    if (!this.$el) return;

    this.currentPage = 1;

    this.$header = document.querySelector('.js-header');
    this.$loadMoreButton = this.$el.querySelector('.js-case-studies-listing-load-more');
    this.$grid = this.$el.querySelector('.js-case-studies-listing-grid');
    this.$noResults = this.$el.querySelector('.js-case-studies-listing-no-results');

    this.$verticalSelect = this.$el.querySelector('.js-case-studies-listing-vertical-select');
    this.$productSelect = this.$el.querySelector('.js-case-studies-listing-product-select');
    this.$integrationSelect = this.$el.querySelector('.js-case-studies-listing-integration-select');

    this.$numberOfVisibleArticles = this.$el.querySelector('.js-case-studies-listing-visible-articles');
    this.$totalArticles = this.$el.querySelector('.js-case-studies-listing-total-articles');
    this.$resetButton = this.$el.querySelector('.js-case-studies-listing-reset-filters');

    this.$verticalSelect?.addEventListener('change', this.filterByVertical.bind(this));
    this.$productSelect?.addEventListener('change', this.filterByProduct.bind(this));
    this.$integrationSelect?.addEventListener('change', this.filterByIntegration.bind(this));

    if (this.$loadMoreButton) {
      this.$loadMoreButtonText = this.$loadMoreButton.querySelector('.c-cta__label');
      this.originalLoadMoreButtonText = this.$loadMoreButtonText.innerText;
      this.$loadMoreButton.addEventListener('click', this.loadMore.bind(this));
    }

    if (this.$resetButton) {
      this.$resetButton.addEventListener('click', this.resetFilters.bind(this));
    }

    if (this.$noResults) {
      this.$noResults.style.display = 'none';
    }

    this.updateResetFilters();
  }

  async execute(params, scrollToTop = true, reset = false) {
    if (reset) {
      this.currentPage = 1;
    } else {
      this.currentPage++;
    }

    this.$grid.classList.add('is-loading');

    if (this.$loadMoreButton) {
      this.$loadMoreButtonText.innerText = 'Loading';
      this.$loadMoreButton.disabled = true;
    }

    const payload = new FormData;
    payload.append('paged', this.currentPage);

    Object.keys(params).forEach(key => {
      payload.append(key, params[key]);
    });

    try {
      const { data } = await axios.post(window.site.api.ajax, payload);

      if (this.$loadMoreButton) {
        this.$loadMoreButtonText.innerText = this.originalLoadMoreButtonText;
        this.$loadMoreButton.disabled = false;

        if (data.is_last_page) {
          this.$loadMoreButton.style.display = 'none';
        } else {
          this.$loadMoreButton.style.display = 'block';
        }
      }

      if (data) {
        this.$grid.innerHTML = reset ? data.response : this.$grid.innerHTML + data.response;
        this.$grid.classList.remove('is-loading');
        this.updateTotal(data.total_articles, scrollToTop);
        this.updateResetFilters();

        if (!data.total_articles) {
          this.$grid.style.display = 'none';
          if (this.$noResults) {
            this.$noResults.removeAttribute('style');
          }

          if (this.$loadMoreButton) {
            this.$loadMoreButton.style.display = 'none';
          }
        } else {
          if (this.$noResults) {
            this.$noResults.style.display = 'none';
          }
          this.$grid.removeAttribute('style');
        }
      } else {
        if (this.$loadMoreButton) {
          this.$loadMoreButton.style.display = 'none';
        }

        this.updateResetFilters();
      }
    } catch (error) {
      this.currentPage = 1;
      this.$grid.classList.remove('is-loading');
    }
  }

  async loadMore() {
    const payload = {
      action: 'theme_case_studies_load_more',
    }

    if (this.selectedVertical) {
      payload['vertical'] = this.selectedVertical;
    }

    if (this.selectedProduct) {
      payload['product'] = this.selectedProduct;
    }

    if (this.selectedIntegration) {
      payload['integration'] = this.selectedIntegration;
    }

    await this.execute(payload, false);
  }

  async filterByVertical(e) {
    if (e.target.value === 'all') {
      this.selectedVertical = undefined;
    } else {
      this.selectedVertical = e.target.value;
    }

    await this.filterByCategory();
  }

  async filterByProduct(e) {
    if (e.target.value === 'all') {
      this.selectedProduct = undefined;
    } else {
      this.selectedProduct = e.target.value;
    }

    await this.filterByCategory();
  }

  async filterByIntegration(e) {
    if (e.target.value === 'all') {
      this.selectedIntegration = undefined;
    } else {
      this.selectedIntegration = e.target.value;
    }

    await this.filterByCategory();
  }

  async filterByCategory(e) {
    const payload = {
      action: 'theme_case_studies_load_more',
    }

    if (this.selectedVertical) {
      payload['vertical'] = this.selectedVertical;
    }

    if (this.selectedProduct) {
      payload['product'] = this.selectedProduct;
    }

    if (this.selectedIntegration) {
      payload['integration'] = this.selectedIntegration;
    }

    await this.execute(payload, true, true);
  }

  async resetFilters() {
    this.selectedVertical = undefined;
    this.selectedProduct = undefined;
    this.selectedIntegration = undefined;

    if (this.$verticalSelect) {
      this.$verticalSelect.selectedIndex = 0;
    }

    if (this.$productSelect) {
      this.$productSelect.selectedIndex = 0;
    }

    if (this.$integrationSelect) {
      this.$integrationSelect.selectedIndex = 0;
    }

    const payload = {
      action: 'theme_case_studies_load_more',
    }

    await this.execute(payload, true, true);
  }

  updateTotal(totalArticles, scrollToTop = true) {
    const total = this.$grid.querySelectorAll('.js-case-studies-card').length;

    this.$numberOfVisibleArticles.innerText = total;
    this.$totalArticles.innerText = totalArticles;
    this.$grid.classList.remove('is-loading');

    if (scrollToTop) {
      window.scrollTo({
        top: this.$el.offsetTop - this.$header.offsetHeight,
        behavior: 'smooth'
      });
    }
  }

  updateResetFilters() {
    if (!this.$resetButton) return;

    if (this.currentPage > 1 || this.selectedVertical || this.selectedProduct || this.selectedIntegration) {
      this.$resetButton.style.display = 'block';
    } else {
      this.$resetButton.style.display = 'none';
    }
  }
}
